import {removeSiteLocaleFromPath} from '@salesforce/retail-react-app/app/utils/url';

import {pushEvent} from '@amblique/king-living/app/analytics/ga4/data-layer';
import {GA4_PAGE_TYPES} from '@amblique/king-living/app/utils/gtm-utils';
import {getSlugFromPathname} from '@amblique/king-living/app/utils/slug-from-path';

const BODY_PAGE_TYPES = {
  'category-listing-page': GA4_PAGE_TYPES.PLP,
  'home-page': GA4_PAGE_TYPES.HOMEPAGE,
  'product-page': GA4_PAGE_TYPES.PDP,
};

const getBodyPageSuffix = () => {
  if (typeof document === 'undefined') {
    return null;
  }

  return [...document.body.classList].find((className) => className.startsWith('page--'))?.slice(6) ?? null;
};

export const resolvePageTypeFromPath = (pathname) => {
  const path = removeSiteLocaleFromPath(pathname) || '/';
  const slug = getSlugFromPathname(pathname);

  if (path === '/' || slug === '' || slug === 'home') {
    return GA4_PAGE_TYPES.HOMEPAGE;
  }

  if (path.startsWith('/checkout')) {
    return GA4_PAGE_TYPES.CHECKOUT;
  }

  if (path.startsWith('/account')) {
    return GA4_PAGE_TYPES.ACCOUNT;
  }

  if (path.startsWith('/cart')) {
    return GA4_PAGE_TYPES.CART;
  }

  if (path.startsWith('/category/') || path === '/search' || path.startsWith('/search/')) {
    return GA4_PAGE_TYPES.PLP;
  }

  if (slug.startsWith('product/') || path.startsWith('/product/')) {
    return GA4_PAGE_TYPES.PDP;
  }

  return null;
};

export const resolvePageTypeFromBody = () => {
  const suffix = getBodyPageSuffix();

  return suffix ? BODY_PAGE_TYPES[suffix] ?? null : null;
};

export const resolvePageType = (pathname) => {
  return resolvePageTypeFromPath(pathname) ?? resolvePageTypeFromBody() ?? GA4_PAGE_TYPES.CONTENT;
};

let lastPageView = {path: '', title: ''};
let lastPageLocation = '';

export const trackPageViewFromSeo = ({
  country,
  currency,
  language,
  pagePath,
  pageTitle,
}) => {
  if (typeof window === 'undefined' || !pagePath) {
    return;
  }

  const normalizedTitle = String(pageTitle ?? '').trim();

  if (!normalizedTitle) {
    return;
  }

  if (lastPageView.path === pagePath && lastPageView.title === normalizedTitle) {
    return;
  }

  const pathname = pagePath.split('?')[0] || pagePath;
  const pageReferrer = lastPageLocation || document.referrer || '';

  lastPageLocation = window.location.href;
  lastPageView = {path: pagePath, title: normalizedTitle};

  pushEvent('page_view', {
    country,
    currency,
    language,
    page_location: window.location.href,
    page_path: pagePath,
    page_referrer: pageReferrer,
    page_title: normalizedTitle,
    page_type: resolvePageType(pathname),
  });
};
